// Sous-bloc pliable pour chaque famille d'equipement.
export default function EquipementBlock({ code, meta, enabled, onToggle, children, ...rest }) {
  return (
    <div className={`rounded-lg border bg-white overflow-hidden transition-colors ${enabled ? 'border-marque' : 'border-neutral-200'}`} {...rest}>
      <button
        type="button"
        onClick={onToggle}
        className={`w-full flex items-center justify-between px-4 py-3 text-left ${enabled ? 'bg-marque text-white' : 'bg-white text-neutral-900'}`}
        data-testid={`toggle-${code}`}
      >
        <div className="flex items-center gap-2">
          <span className={`text-[10px] uppercase tracking-wider px-1.5 py-0.5 rounded ${enabled ? 'bg-white/10' : meta.color}`}>{code}</span>
          <span className="text-[13px] font-medium">{meta.label}</span>
        </div>
        <span className={`text-[11px] ${enabled ? 'text-white/80' : 'text-neutral-400'}`}>{enabled ? '— Inclus' : '+ Ajouter'}</span>
      </button>
      {enabled && (
        <div className="p-4 space-y-3 border-t border-neutral-100">
          {children}
        </div>
      )}
    </div>
  );
}
